import React from 'react';
import styled from 'styled-components';
import { InfoIcon } from '../../components/Form/InfoIcon';
import { toPounds } from '../../services/Formats';
import { IColorIndex, INumKeyStringMap } from './types';
import { ILtvCalcInput, ILtvCalcOutput } from './../../services/types';
import { MinHousePrice } from './../../services/LtvCalc';

const ErrorBox = styled.div`
  color: var(--color-error);
  width: auto; 
  max-width: 380px;
  margin: 0px auto;

  background: url(images/excl.png) no-repeat 3px 18px;
  border: 2px var(--color-error) solid;
  border-radius: 5px;
  text-align: left;
  padding: 20px;
  padding-left: 50px;
  font-weight: bold;
`;

/*
 > button.im {
   min-height: 300px;
   background: url(images/temperature-gray.png) no-repeat 0px 0px;
   background-size: 100%;
 }
 > button.im.active { background-image: url(images/temperature-lightblue.png); }
 > button.im:hover { background-image: url(images/temperature-lightblue.png); }
*/

const LevelsTopDiv = styled.div`
  position: relative;
  padding-bottom: 130px;
  @media(max-width:480px) { padding-bottom: 180px; }
`;

const Columns2 = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 20px;
  .pct { color: var(--color-main); text-align: center; font-weight: bold; font-family: 'Nunito Sans',arial; font-size: 22px;  }
  > .person { width: 60%; }
`;

const LevelsDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;

  .title {
     width: 100%;
     background: transparent;
     text-align: center;
     color: #000;
     font-size: 16px;
     font-weight: bold;
     font-family: 'Nunito Sans',arial;
  }
  .subtitle {
    text-align: center;
  }
  .amount {
    padding-top: 5px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: var(--color-main);
  }
  .amount.index-2 {
    padding-top: 1px;
  }
  @media(max-width:640px) { .title { font-size: 12px; font-weight: normal; } }
  @media(max-width:480px) { .title { font-size: 10px; font-weight: normal; } }

  .person {
    @media(max-width:640px) { img { width: 45px; } }
    @media(max-width:480px) { img { width: 35px; } }
  }

  > button {
    width: 25%;
    border: none;
    cursor: pointer;
    outline: none !important;
    background: transparent;
  }

  .hint {
    display: none;
    position: absolute;
    top: 295px;
    left: 5%;
    width: 80%;
    background: #6c7286;
    color: white;
    font-family: 'Nunito Sans',arial;
    font-size: 16px;
    padding: 30px;

    @media(max-width:640px) { top: 240px; }
    @media(max-width:480px) { top: 200px; }
  }

  > button.active .hint { display: block; }

  > .level { width:22%; max-width: 22%; }
  > .level:hover .hint { display: block; }
  > .level .arrow { display: none; }
  > .level:hover .arrow { display: block; }

  .coins {
    width: 46px;
    background: url(images/coins-bk.png) 0px 0px no-repeat;
    background-size: 100%;
    position: relative;

    img {
      width: 46px;
      position: absolute;
      left: 0px;
      bottom: 0px;
    }
    @media(max-width:640px) { width: 35px; img { width: 35px; }}
    @media(max-width:680px) { width: 25px; img { width: 25px; }}
  }
  .pct {
    @media(max-width:640px) { font-size: 16px }
    @media(max-width:480px) { font-size: 14px }
  }
`;

const T: Array<string> = ['MinLoan', 'Healthy', 'Unhealthy'];
const TTL: Array<string> = ['Minimum Loan', 'Average Loan', 'Maximum Loan'];
const SUBTL: Array<string> = ['facility*', 'on standard terms', 'on standard terms'];
const IMG: Array<string> = ['images/level-0.png', 'images/level-1.png', 'images/level-2.png'];
const HINT: Array<string> = [
  '',
  '',
  ''
];


const GrayArrowDiv = styled.div`
  position: absolute;
  top: 280px;
  @media(max-width:640px) { top: 225px; }
  @media(max-width:480px) { top: 190px; }

`;

 const GrayArrow = (props: IColorIndex) => {
  const { color, index } = props;
  const positions: INumKeyStringMap = { 0: '20%', 1: '50%', 2: '86%' };
  if (!positions[index]) return null;

  return (
    <GrayArrowDiv className="arrow" style={{ left: positions[index] }}>
      <svg height="12" width="31" viewBox='0 0 31 12'>
		    <polygon style={{ fill: color }} points="0,11 15,0 29,11" />
      </svg>
    </GrayArrowDiv>
  );
}

const maxPctValue = 59 * 1.3;
const maxCoinsHeight = 130;
export const LevelsOfEnhancement = (props: any) => {
  const input: ILtvCalcInput = props.input;
  const output: ILtvCalcOutput = props.output.ltv;
  if (input.housePrice < MinHousePrice) return (
    <ErrorBox>
      Your client doesn’t qualify for equity release<br />
      The minimum value of a home to qualify is {toPounds(MinHousePrice)}
    </ErrorBox>
  );
  return (
    <LevelsTopDiv>
        {(output.maxHousePrice < input.housePrice) ? (
            <div style={{color: 'red', width: '100%', textAlign: 'center', padding: '12px'}}>
                The property value entered is above the maximum allowed for this calculator. If your property is currently valued at more than £{ output.maxHousePrice.toLocaleString() } please contact us for a personalised illustration.
            </div>
        ) : (
            <div style={{display: 'none'}}>!</div>
        )}
      <LevelsDiv className="levels-div" key={1}>
        {T.map((t: string, index: number) => (
          <div className="level" key={index}>
            <div>
              <Columns2>
                <div className='person'>
                  <img src={IMG[index]} alt={input.ltvPlan} />
                </div>
                <div>
                    <div className="pct">{(output.pct[t] == undefined) ? 0 : parseFloat(output.pct[t].toString()).toFixed(1)}%</div>
                  <div className="coins" style={{ height: output.pct[t] * maxCoinsHeight / maxPctValue }} >
                    <img src="images/coins-under-bk.png" alt="" />
                  </div>
                </div>
              </Columns2>
            </div>
            <div className={`title ${(t === input.ltvPlan) ? 'active' : ''}`}>
              {TTL[index]}
            </div>
            <div className="subtitle">{SUBTL[index]}</div>
            <div className={`amount index-${index}`}>
                {(output.plans[t] < 10000) ? toPounds(10000) : toPounds(output.plans[t])}
              {(!HINT[index]) ? false : <InfoIcon />}
            </div>

            {(!HINT[index]) ? false : <GrayArrow index={index} color='#6c7286' />}
            {(!HINT[index]) ? false : <div className="hint">{HINT[index]}</div>}
          </div>
        ))}
      </LevelsDiv>
      <div style={{ paddingTop: 30, lineHeight: 1, fontSize: '11px' }}>*subject to minimum initial release of £10,000</div>
        <div style={{ paddingTop: 30, lineHeight: 1, fontSize: '11px' }}>The figures are illustrative only, based on LTVs published as @ 08/02/23. Actual LTVs available at the time of application will depend on the product chosen. They may be higher or lower than the figures displayed above and subject to change. Average LTVs are based on data from Key Group and show the typical amount released at each age.'</div>

    </LevelsTopDiv>
  );
};
